import { Link } from "react-router-dom";
import { default as LogoDark2x, default as LogoLight2x, default as LogoSmall } from "../../images/logo/logo.png"; //../../assets/images/logo/logo.png

const Logo = () => {
  const userDetail =  (localStorage.getItem("type")); 
  return (
    <Link to={ userDetail=="lms_admin" ? `${process.env.PUBLIC_URL}/lms-dashboard` : `${process.env.PUBLIC_URL}/`} className="logo-link">
      {/* <img className="logo-light logo-img" src={LogoLight2x} alt="logo" /> */}
      {/* <img className="logo-dark logo-img" src={LogoDark2x} alt="logo" /> */}
      <img className="logo-small logo-img logo-img-small" src={LogoSmall} alt="logo" />
    </Link>
  );
};

export default Logo;
